// Appearance preference: 'system' (default, follows the OS), 'light' or 'dark'. Stored per device in
// localStorage and applied as <html data-theme>. 'system' removes the attribute so the CSS media query decides.
// The same logic runs once, before first paint, from the inline script in public/index.html (no flash).
export const THEME_KEY = 'zaptude_theme';
export const THEMES = ['system', 'light', 'dark'];

export function getStoredTheme() {
  try { const v = localStorage.getItem(THEME_KEY); return THEMES.includes(v) ? v : 'system'; } catch { return 'system'; }
}

export function resolveTheme(pref, prefersDark) {
  if (pref === 'dark' || pref === 'light') return pref;
  return prefersDark ? 'dark' : 'light';
}

const THEME_COLOR = { light: '#4c1d95', dark: '#0e0c1b' };

export function applyTheme(pref) {
  const root = document.documentElement;
  if (pref === 'dark' || pref === 'light') root.setAttribute('data-theme', pref); else root.removeAttribute('data-theme');
  const prefersDark = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', THEME_COLOR[resolveTheme(pref, prefersDark)]);
}

export function setTheme(pref) {
  const next = THEMES.includes(pref) ? pref : 'system';
  try { localStorage.setItem(THEME_KEY, next); } catch { /* private mode: applies for this session only */ }
  applyTheme(next);
  return next;
}

// Keep 'system' live if the OS setting changes while the app is open.
export function watchSystemTheme() {
  if (typeof window.matchMedia !== 'function') return () => {};
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const on = () => { if (getStoredTheme() === 'system') applyTheme('system'); };
  if (mq.addEventListener) mq.addEventListener('change', on);
  return () => { if (mq.removeEventListener) mq.removeEventListener('change', on); };
}
